import React from 'react';
import { Filter, List, Edit, Create, SimpleForm,
  Datagrid, TextField, TextInput, EditButton, Responsive,
  SimpleList } from 'react-admin';


export const AdministradorFilter = (props) => (
  <Filter {...props}>
   <TextInput label="Nombre" source="searchnombre" autoFocus alwaysOn />
   <TextInput label="Usuario" source="searchdni" autoFocus />
  </Filter>
);

const AdministradorNameEdit = ({ record }) => {
  return (
    <Responsive small={
      <span>
        Editar Administrador
      </span>
    }
    medium={
      <span>
        Editar Administrador: {record ? `"${record.nombre}"` : ''}
      </span>
    }
    />

  );
};

export const AdministradorEdit = (props) => (
    <Edit title={<AdministradorNameEdit />} {...props}>
        <SimpleForm>
          <TextInput label="Nombre y Apellido" source="nombre" />
          <TextInput label="Usuario" source="dni" />
          <TextInput label="Contraseña" source="validacion" type="password" />
        </SimpleForm>
    </Edit>
);

export const AdministradorCreate = (props) => (
    <Create title="Registrar Administrador" {...props}>
        <SimpleForm redirect="/administradores">
          <TextInput label="Nombre y Apellido" source="nombre" />
          <TextInput label="Usuario" source="dni" />
          <TextInput label="Contraseña" source="validacion" type="password" />
        </SimpleForm>
    </Create>
);

export const EditableAdministradorList = (props) => (
    <List
      {...props}
      bulkActions={false}
      filters={<AdministradorFilter />}
      exporter={false}
    >
    <Responsive small={
      <SimpleList
          primaryText={record => record.nombre}
          tertiaryText={record => 'Usuario: ' + record.dni}
      />
    }
    medium={
      <Datagrid>
          <TextField source="nombre" />
          <TextField source="dni" label="Usuario" />
          <EditButton />
      </Datagrid>
    }
    />
    </List>
);



// WEBPACK FOOTER //
// ./src/services/administradores.js